module.exports = __webpack_public_path__ + "static/media/arrow_down.3a20d126.svg";